var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 9H0V3.45C0 3.15.15 3 .45 3h23.1c.3 0 .45.15.45.45V9z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.55 21H.45c-.3 0-.45-.15-.45-.45V15h24v5.55c0 .3-.15.45-.45.45z",
    fill: "#FF4B55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9H0v6h24V9z",
    fill: "#41479B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85 16.5C4.5 15 3 13.5 3 12V7.5h6V12c0 1.5-2.85 4.35-3 4.5h-.15z",
    fill: "#1641D5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.25l-.955.14h-.272V10.8l.272.03.682.14-.136-.422.136-.422-.682.14h-.272v-.28L6.75 9h-1.5l.477.984v.282h-.136l-.682-.141.136.422-.136.422.682-.14h.136v.562h-.272L4.5 11.25l.136.422-.136.422.955-.14h.272l-.136 1.85h.807l-.125-1.85h.272l.955.14-.136-.422.136-.422z",
    fill: "#F5F5F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.5c-.75 0-1.5.75-1.5 1.5 0 0 .214-.9 0-.9-.857 0-1.5.36-1.5.84 1.286.96 2.786 1.56 2.786 1.56h.428s1.5-.6 2.786-1.56c0-.48-.643-.84-1.5-.84 0 0 .214.9 0 .9 0-.75-.857-1.5-1.5-1.5z",
    fill: "#41479B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.5v4.2C9 13.5 6 15 6 15s-3-1.5-3-3.3V7.5h6zM10.5 6h-9v6c0 3.15 4.5 4.5 4.5 4.8 0-.3 4.5-1.65 4.5-4.8V6z",
    fill: "#F5F5F5"
  })));
}
export default SvgSlreact;